<template>
  <common-card class="mt-3">
    <v-row>
      <v-col>
        <v-row style="padding: 15px 20px 0px 20px;">
          <v-col cols="12">
            <h1>Crear producto para alianza</h1>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <CommonActionModal
      :dialog="confirmDialog"
      title="¿Deseas crear este producto?"
      subtitle="Revisa los datos antes de continuar."
      bottonText="Sí, crear"
      bottonTextCancel="Cancelar"
      @closeModal="confirmDialog = false"
      @userChoice="handleConfirmCreate"
    />

    <v-container>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row class="padding-pefai">
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="producto.alianza_intermx_id"
              label="Alianza Inter.mx*"
              :items="alianzasOptions"
              item-text="nombre"
              item-value="id"
              :rules="[rules.required]"
              @change="handleAlianzaChange"
              outlined
              color="#00a7e4"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="producto.ramo_id"
              label="Ramo*"
              :items="filteredRamosOptions"
              item-text="etiqueta"
              item-value="id"
              :rules="[rules.required]"
              @change="handleRamoChange"
              :disabled="filteredRamosOptions.length === 1"
              outlined
              color="#00a7e4"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="producto.canal"
              label="Canal*"
              :items="filteredCanalesOptions"
              item-text="etiqueta"
              item-value="canal"
              :rules="[rules.required]"
              :disabled="filteredCanalesOptions.length === 1"
              outlined
              color="#00a7e4"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="producto.nombre"
              label="Nombre*"
              :rules="[rules.required]"
              outlined
              color="#00a7e4"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="producto.aseguradora_id"
              label="Aseguradora*"
              :items="aseguradorasOptions"
              item-text="nombre"
              item-value="id"
              :rules="[rules.required]"
              outlined
              color="#00a7e4"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="producto.status"
              label="Status"
              outlined
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-select
              v-model="producto.vigencia"
              label="Vigencia*"
              :items="vigenciaOptions"
              :rules="[rules.required]"
              outlined
              color="#00a7e4"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="producto.prima_neta"
              label="Prima neta*"
              type="number"
              min="0"
              :rules="[rules.required, rules.number]"
              outlined
              color="#00a7e4"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="producto.total"
              label="Total*"
              type="number"
              min="0"
              :rules="[rules.required, rules.number]"
              outlined
              color="#00a7e4"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="producto.primer_pago"
              label="Primer pago*"
              type="number"
              min="0"
              :rules="[rules.required, rules.number]"
              outlined
              color="#00a7e4"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="producto.subsecuente_pago"
              label="Pago subsecuente*"
              type="number"
              min="0"
              :rules="[rules.required, rules.number]"
              outlined
              color="#00a7e4"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="producto.suma_asegurada"
              label="Suma asegurada*"
              type="number"
              min="0"
              :rules="[rules.required, rules.number]"
              outlined
              color="#00a7e4"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="producto.dias_periodo_gracia"
              label="Días periodo de gracia"
              type="number"
              min="0"
              :rules="[rules.number]"
              outlined
              color="#00a7e4"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-checkbox v-model="producto.certificado" label="Certificado" color="#00a7e4"></v-checkbox>
          </v-col>

          <v-col cols="12" md="6">
            <v-checkbox v-model="producto.cuotas" label="Cuotas" color="#00a7e4"></v-checkbox>
          </v-col>

          <v-col cols="12" md="6">
            <v-checkbox v-model="producto.beneficiario" label="Beneficiario" color="#00a7e4"></v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Configuraciones extras
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model.number="producto.comisionAgente"
                        label="% Comisión Agente"
                        type="number"
                        min="0"
                        max="100"
                        :rules="[rules.number, rules.percentage]"
                        outlined
                        color="#00a7e4"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model.number="producto.bono"
                        label="% Bono"
                        type="number"
                        min="0"
                        max="100"
                        :rules="[rules.number, rules.percentage]"
                        outlined
                        color="#00a7e4"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model.number="producto.comisionAseguradora"
                        label="% Comisión pagada por la aseguradora"
                        type="number"
                        min="0"
                        max="100"
                        :rules="[rules.number, rules.percentage]"
                        outlined
                        color="#00a7e4"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model.number="producto.comisionSegurify"
                        label="Comisión Segurify"
                        type="number"
                        min="0"
                        :rules="[rules.number]"
                        outlined
                        color="#00a7e4"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model.number="producto.comisionTotal"
                        label="Comisión total"
                        type="number"
                        min="0"
                        :rules="[rules.number]"
                        outlined
                        color="#00a7e4"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model.number="producto.limite_beneficiarios"
                        label="Límite beneficiarios"
                        type="number"
                        min="0"
                        :rules="[rules.number]"
                        outlined
                        color="#00a7e4"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model.number="producto.limite_familiares"
                        label="Límite familiares"
                        type="number"
                        min="0"
                        :rules="[rules.number]"
                        outlined
                        color="#00a7e4"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model.number="producto.limite_hijos"
                        label="Límite hijos"
                        type="number"
                        min="0"
                        :rules="[rules.number]"
                        outlined
                        color="#00a7e4"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-checkbox
                        v-model="producto.tecnologia"
                        label="Tecnología"
                        color="#00a7e4"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-checkbox
                        v-model="producto.inbound"
                        label="Inbound"
                        color="#00a7e4"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>

        <v-row class="mt-5">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn rounded dark outlined color="#00a7e4" class="mr-4" @click="$router.push('/administracion/productos-alianzas')">
              Cancelar
            </v-btn>
            <v-btn rounded dark class="common-botton" :loading="loading" @click="crearProducto">
              Crear
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </common-card>
</template>

<script>
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import CommonActionModal from "@/components/commonComponents/CommonActionModal.vue";
import { getAlianzas, getAlianzaById } from "../../../../../services/alianzas/alianzas.service";
import { getCanalList } from "../../../../../services/canal/canal.service";
import { getRamoList } from "../../../../../services/ramo/ramo.service";
import { getAseguradorasList } from "../../../../../services/aseguradoras/aseguradoras.service";
import { insertProduct } from "../../../../../services/productos/product.service";

export default {
  name: "CrearProductoAlianza",
  components: {
    CommonCard,
    CommonActionModal,
  },
  data() {
    return {
      valid: true,
      loading: false,
      confirmDialog: false,
      producto: {
        alianza_intermx_id: null,
        ramo: null,
        ramo_id: null,
        canal: null,
        nombre: "",
        aseguradora_id: null,
        status: "Activo",
        vigencia: null,
        certificado: false,
        cuotas: false,
        beneficiario: false,
        comisionAgente: null,
        bono: null,
        comisionAseguradora: null,
        limite_beneficiarios: null,
        limite_familiares: null,
        limite_hijos: null,
        dias_periodo_gracia: null,
        prima_neta: null,
        total: null,
        primer_pago: null,
        subsecuente_pago: null,
        suma_asegurada: null,
        comisionSegurify: null,
        comisionTotal: null,
        tecnologia: false,
        inbound: false,
      },
      selectedAlianzaRamos: [],
      selectedAlianzaCanales: [],
      rules: {
        required: (value) => !!value || "Este campo es requerido",
        number: (value) =>
          value === null || value === "" || value === undefined ||
          (!isNaN(value) && Number(value) >= 0) ||
          "Debe ser un número válido mayor o igual a 0",
        percentage: (value) => {
          if (value === null || value === "" || value === undefined) return true;
          return (!isNaN(value) && Number(value) >= 0 && Number(value) <= 100) || "El porcentaje debe estar entre 0 y 100";
        },
      },
      alianzasOptions: [],
      ramosOptions: [],
      canalesOptions: [],
      aseguradorasOptions: [],
      vigenciaOptions: ["Mensual", "Anual", "Semestral", "Trimestral"],
    };
  },
  computed: {
    filteredRamosOptions() {
      if (!this.selectedAlianzaRamos.length) {
        return this.ramosOptions;
      }
      return this.ramosOptions.filter((ramo) =>
        this.selectedAlianzaRamos.includes(ramo.id),
      );
    },
    filteredCanalesOptions() {
      if (!this.selectedAlianzaCanales.length) {
        return this.canalesOptions;
      }

      return this.canalesOptions.filter((canal) =>
        this.selectedAlianzaCanales.includes(canal.id)
      );
    },
  },
  mounted() {
    this.getAlianzasOptions();
    this.getRamosOptions();
    this.getCanalesOptions();
    this.getAseguradorasOptions();
  },
  methods: {
    async getAlianzasOptions() {
      this.alianzasOptions = await getAlianzas();
    },

    async getRamosOptions() {
      const response = await getRamoList();
      this.ramosOptions = Array.isArray(response)
        ? response
        : response ?? [];
    },

    async getCanalesOptions() {
      const response = await getCanalList();
      this.canalesOptions = Array.isArray(response)
        ? response
        : [];
    },

    async getAseguradorasOptions() {
      const response = await getAseguradorasList();
      this.aseguradorasOptions = Array.isArray(response)
        ? response
        : response?.data ?? [];
    },

    async handleAlianzaChange(value) {
      if (!value) {
        this.selectedAlianzaRamos = [];
        this.selectedAlianzaCanales = [];

        this.producto.ramo = null;
        this.producto.ramo_id = null;
        this.producto.canal = null;
        this.producto.aseguradora_id = null;

        return;
      }

      try {
        const response = await getAlianzaById(value);

        const alianzaData =
          response?.alianza ||
          response?.data ||
          response;

        if (!alianzaData) {
          return;
        }

        // RAMOS
        if (
          Array.isArray(alianzaData.ramosList) &&
          alianzaData.ramosList.length
        ) {
          this.selectedAlianzaRamos =
            alianzaData.ramosList.map((item) => item.id);

          if (alianzaData.ramosList.length === 1) {
            const selectedRamo = alianzaData.ramosList[0];

            this.producto.ramo =
              selectedRamo.ramo ||
              selectedRamo.etiqueta ||
              null;

            this.producto.ramo_id = selectedRamo.id;

          } else {
            const currentRamoId = this.producto.ramo_id;

            if (
              !this.selectedAlianzaRamos.includes(currentRamoId)
            ) {
              this.producto.ramo = null;
              this.producto.ramo_id = null;
            }
          }

        } else {
          this.selectedAlianzaRamos = [];
          this.producto.ramo = null;
          this.producto.ramo_id = null;
        }

        // CANAL
        if (alianzaData.canal) {
          const canalMatch = this.canalesOptions.find(
            (canal) =>
              Number(canal.id) === Number(alianzaData.canal)
          );

          if (canalMatch) {
            this.selectedAlianzaCanales = [canalMatch.id];

            this.producto.canal =
              canalMatch.canal ||
              null;

          } else {
            this.selectedAlianzaCanales = [];
            this.producto.canal = null;
          }

        } else {
          this.selectedAlianzaCanales = [];
          this.producto.canal = null;
        }

        // ASEGURADORA
        if (alianzaData.aseguradoraId) {
          this.producto.aseguradora_id =
            alianzaData.aseguradoraId;

        } else if (alianzaData.aseguradora) {
          const match = this.aseguradorasOptions.find(
            (item) =>
              item.nombre?.toLowerCase() ===
              String(alianzaData.aseguradora).toLowerCase()
          );

          if (match) {
            this.producto.aseguradora_id = match.id;
          }
        }

      } catch (error) {
        console.error(
          "Error al cargar los datos de la alianza:",
          error
        );
      }
    },

    handleRamoChange(value) {
      const selected = this.ramosOptions.find(
        (item) => item.id === value
      );

      if (!selected) {
        this.producto.ramo = null;
        this.producto.ramo_id = null;
        return;
      }

      this.producto.ramo = selected.ramo;
      this.producto.ramo_id = selected.id;

      if (selected.canal) {
        const canalMatch = this.canalesOptions.find(
          (c) =>
            Number(c.id) === Number(selected.canal) ||
            c.canal === selected.canal ||
            c.etiqueta === selected.canal
        );

        this.producto.canal = canalMatch
          ? canalMatch.canal
          : null;
      }
    },

    getMissingRequiredFields() {
      const requiredFields = {
        alianza_intermx_id: this.producto.alianza_intermx_id,
        ramo_id: this.producto.ramo_id,
        canal: this.producto.canal,
        nombre: this.producto.nombre,
        aseguradora_id: this.producto.aseguradora_id,
        vigencia: this.producto.vigencia,
      };

      return Object.values(requiredFields).filter((value) => !value).length;
    },

    cleanPayloadValue(value) {
      if (value === null || value === undefined) {
        return null;
      }

      if (typeof value === "string") {
        const trimmedValue = value.trim();
        return trimmedValue === "" ? null : trimmedValue;
      }

      return value;
    },

    async crearProducto() {
      const isFormValid = this.$refs.form ? this.$refs.form.validate() : false;
      if (!isFormValid) {
        this.$toast.error("Se necesitan los campos requeridos", {
          position: "top-right",
          timeout: 3000,
        });
        return;
      }

      this.confirmDialog = true;
    },

    async handleConfirmCreate(confirmed) {
      if (!confirmed) {
        this.confirmDialog = false;
        return;
      }

      this.confirmDialog = false;
      this.loading = true;

      const payload = {
          alianza_intermx_id: this.cleanPayloadValue(this.producto.alianza_intermx_id),
          ramo: this.cleanPayloadValue(this.producto.ramo),
          ramo_id: this.cleanPayloadValue(this.producto.ramo_id),
          canal: this.cleanPayloadValue(this.producto.canal),
          nombre: this.cleanPayloadValue(this.producto.nombre),
          aseguradora_id: this.cleanPayloadValue(this.producto.aseguradora_id),
          vigencia: this.cleanPayloadValue(this.producto.vigencia),

          certificado: this.producto.certificado,
          cuotas: this.producto.cuotas,
          beneficiario: this.producto.beneficiario,

          comision_agente: this.cleanPayloadValue(this.producto.comisionAgente),
          bono: this.cleanPayloadValue(this.producto.bono),
          comision_aseguradora: this.cleanPayloadValue(this.producto.comisionAseguradora),
          comision_segurify: this.cleanPayloadValue(this.producto.comisionSegurify),
          comision_total: this.cleanPayloadValue(this.producto.comisionTotal),

          limite_beneficiarios: this.cleanPayloadValue(this.producto.limite_beneficiarios),
          limite_familiares: this.cleanPayloadValue(this.producto.limite_familiares),
          limite_hijos: this.cleanPayloadValue(this.producto.limite_hijos),
          dias_periodo_gracia: this.cleanPayloadValue(this.producto.dias_periodo_gracia),

          prima_neta: this.cleanPayloadValue(this.producto.prima_neta),
          total: this.cleanPayloadValue(this.producto.total),
          primer_pago: this.cleanPayloadValue(this.producto.primer_pago),
          subsecuente_pago: this.cleanPayloadValue(this.producto.subsecuente_pago),
          suma_asegurada: this.cleanPayloadValue(this.producto.suma_asegurada),

          tecnologia: this.producto.tecnologia,
          inbound: this.producto.inbound,

          agente_id: Number(localStorage.id || 0),
        };
      try {
        await insertProduct(payload);
        this.$toast.success("Producto creado correctamente", {
          position: "top-right",
          timeout: 3000,
        });
        this.$router.push("/administracion/productos-alianzas");
      } catch (error) {
        console.error("Error al crear producto:", error);
        const mensaje = error.response?.data || "Error desconocido al crear el producto";
        this.$toast.error(mensaje, {
          position: "top-right",
          timeout: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-text-field--outlined fieldset {
  border-color: rgba(0, 0, 0, 0.12);
}

.common-botton {
  background-color: #00a7e4 !important;
}
</style>
